import { render, staticRenderFns } from "./FormLog.vue?vue&type=template&id=6bfbfcb2&"
import script from "./FormLog.vue?vue&type=script&lang=js&"
export * from "./FormLog.vue?vue&type=script&lang=js&"
import style0 from "./FormLog.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports